import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("he_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function trackLead(type) {
  try {
    if (window.fbq) window.fbq("track", "Lead", { content_category: type });
    if (window.gtag) window.gtag("event", "generate_lead", { lead_type: type });
  } catch (e) {
    /* noop */
  }
}

export function errMsg(err, fallback = "Bir hata oluştu. Lütfen tekrar deneyin.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(", ") || fallback;
  if (d && typeof d === "object") return d.msg || fallback;
  return fallback;
}

export function getUTM() {
  const params = new URLSearchParams(window.location.search);
  const ua = navigator.userAgent.toLowerCase();
  return {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    referrer: document.referrer || undefined,
    device: /iphone|android|mobile/.test(ua) ? "mobile" : "desktop",
  };
}
